class Controller {
  constructor($mdDialog, users, packageId, cityName) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.users = users;
    this.packageId = packageId;
    this.cityName = cityName;
  }

  close() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/commuterPackage/existingUsers/existingUsers.controller.js